module.exports = __webpack_public_path__ + "assets/images/CAD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CAD50.png
// module id = 1330
// module chunks = 1